import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";

const DaajiMessageVideo = ({ homeProp, eventInfo }) => {
  const [modalShow, setModalShow] = React.useState(false);
  // const [videoType, setVideoType] = React.useState("player");
  const [videoLink, setVideoLink] = React.useState("");

  if (homeProp && eventInfo.length < 1) {
    return null;
  }

  const loadVideo = (language) => {
    setModalShow(true);
    const link =
      eventInfo?.find((item) => item?.language === language)?.link || "#";
    // setVideoType(type);
    setVideoLink(link);
  };

  return (
    <>
      <div className="daaji_wrrapper">
        <div className="container">
          {eventInfo.length > 0 && (
            <div className="daaji_box">
              <h2 className="message-sub-heading">
                <span>Video</span>
              </h2>
              <h6 className="mb-4">
                Choose your Language:
                <br />
              </h6>
              {eventInfo.map((item) => (
                <div className="col-sm-6 col-md-3">
                  <div
                    role="button"
                    tabIndex={0}
                    className="message-contents"
                    onClick={() => {
                      loadVideo(item.language);
                    }}
                    onKeyDown={() => {
                      loadVideo(item.language);
                    }}
                  >
                    {item.language}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="video-modal-90w"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Daaji&apos;s Message
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="video text-center">
            <video width="100%" height="" controls>
              <source src={videoLink} type="video/mp4" />
              <track kind="captions" srcLang="en" label="english_captions" />
            </video>
            {/* videoType === 'youtube' &&
              <iframe
                width="560"
                height="315"
                src={videoLink}
                title=""
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

DaajiMessageVideo.propTypes = {
  homeProp: PropTypes.bool,
  eventInfo: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      language: PropTypes.string,
    })
  ),
};

DaajiMessageVideo.defaultProps = {
  homeProp: false,
  eventInfo: [],
};

export default DaajiMessageVideo;
